if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.nav = this.querySelector('[data-tabs-nav]');

      this.nav.addEventListener('click', (e) => {
        if (
          !e.target.hasAttribute('data-tabs-button') ||
          e.target.classList.contains('is-active')
        )
          return;

        const button = e.target;
        const activeButton = this.nav.querySelector(
          '[data-tabs-button].is-active',
        );

        const matchingTab = this.querySelector(
          `[data-tab="${button.dataset.tabsButton}"]`,
        );
        const activeTab = this.querySelector('[data-tab].is-active');

        button.classList.add('is-active');
        activeButton.classList.remove('is-active');

        matchingTab.classList.add('is-active');
        activeTab.classList.remove('is-active');
      });

      Fancybox.bind(`[data-fancybox]`, {})
    }
  }
  customElements.define('tabs-component', TabsComponent);
}
